import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {CdkOverlayOrigin, ConnectedPosition} from '@angular/cdk/overlay';
import {LayoutSize} from '../../../../enums/layout-size.enum';
import {SidebarDrawer} from './sidebar-drawer/sidebar-drawer.model';
import {AppState} from '../../../../state/app/app.state';
import {Subscription} from 'rxjs';
import {Store} from '@ngxs/store';
import {SidebarDrawerComponent} from './sidebar-drawer/sidebar-drawer.component';
import {NavService} from '../../../../services/nav.service';
import PositionConfig = SidebarDrawer.PositionConfig;
import Direction = SidebarDrawer.Direction;
import PositionConfigItem = SidebarDrawer.PositionConfigItem;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SidebarComponent implements OnInit {
    @Input() anchor: CdkOverlayOrigin;
    @Input() isOpen = false;
    @Input() trigger: ElementRef;
    @Output() isOpenChange = new EventEmitter<boolean>();
    @ViewChild(SidebarDrawerComponent) sidebarDrawerComponent: SidebarDrawerComponent;
    positionConfig: PositionConfig = {
        [LayoutSize.SM]: {
            direction: Direction.right,
            padded: true,
            fullwidth: true,
        },
        [LayoutSize.MD]: {
            direction: Direction.right,
            backdrop: true,
            padded: true,
        },
        [LayoutSize.LG]: {
            direction: Direction.left,
        },
    };
    layoutPositionConfigItem: PositionConfigItem;
    overlayPositions: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        },
    ];
    subscription = new Subscription();

    constructor(
        protected store: Store,
        protected cd: ChangeDetectorRef,
        protected navService: NavService
    ) {}

    get viewportMargin() {
        return -this.anchor?.elementRef?.nativeElement?.height - 1;
    }

    ngOnInit() {
        this.subscription.add(
            this.store.select(AppState.layoutSize).subscribe((layout) => this.setPositionConfigForLayout(layout))
        );
    }

    protected setPositionConfigForLayout(layout: LayoutSize) {
        const layoutToApply = this.getLayoutToApply(layout);
        if (layoutToApply) {
            this.layoutPositionConfigItem = this.positionConfig[layoutToApply];
            this.cd.markForCheck();
        }
    }

    /**
     * pick layout from available in config
     */
    protected getLayoutToApply(layout: LayoutSize): string {
        const layoutKey = '' + layout;
        if (!this.positionConfig) {
            return null;
        } else if (layoutKey in this.positionConfig) {
            return layoutKey;
        } else {
            const keys = Object.keys(this.positionConfig).concat(layoutKey);
            keys.sort();
            if (keys.indexOf(layoutKey) === 0) {
                return keys[1];
            } else {
                const index = keys.indexOf(layoutKey);
                return keys[index - 1];
            }
        }
    }

    closeSidebar() {
        this.isOpenChange.emit(false);
        this.sidebarDrawerComponent.isOpen = false;
    }
}
